// extracted by mini-css-extract-plugin
module.exports = {"hightContrast":"style_hightContrast__BlE95","custom_cursor_hover":"style_custom_cursor_hover__uoPxU"};